import { render, staticRenderFns } from "./EvaluationStudentList.vue?vue&type=template&id=b3bc691a&"
import script from "./EvaluationStudentList.vue?vue&type=script&lang=js&"
export * from "./EvaluationStudentList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationStudentList.vue?vue&type=style&index=0&id=b3bc691a&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports